class SendcloudServicePoint extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-action="openPicker"]').forEach(btn => {
      btn.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); this.openPicker(); });
    });
    this.querySelectorAll('[data-action="clearServicePoint"]').forEach(btn => {
      btn.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); this.clearServicePoint(); });
    });
  }

  async openPicker() {
    const postalInput = this.querySelector("[ref=postalInput]");
    const postalCode = postalInput ? postalInput.value.trim() : "";
    if (!postalCode) { this.showError("Introduce un codigo postal"); return; }

    const searchBtn = this.querySelector('[data-action="openPicker"]');
    if (searchBtn) { searchBtn.textContent = "Buscando..."; searchBtn.disabled = true; }

    const carriers = (this.dataset.carriers || "").split(",").filter(Boolean);
    const country = this.dataset.country || "es";
    const apiKey = this.dataset.apiKey;
    const secretKey = this.dataset.secretKey;

    try {
      let url = "https://servicepoints.sendcloud.sc/api/v2/service-points/?country=" +
        country.toUpperCase() + "&address=" + encodeURIComponent(postalCode);
      carriers.forEach(c => { url += "&carrier=" + encodeURIComponent(c); });

      const resp = await fetch(url, {
        headers: { "Authorization": "Basic " + btoa(apiKey + ":" + secretKey) }
      });
      const points = await resp.json();

      if (Array.isArray(points) && points.length > 0) {
        this.showResults(points.slice(0, 8), postalCode);
      } else {
        this.showError("No se encontraron puntos de recogida cerca de " + postalCode);
      }
    } catch (err) {
      this.showError("Error al buscar puntos de recogida");
    } finally {
      if (searchBtn) { searchBtn.textContent = "Buscar"; searchBtn.disabled = false; }
    }
  }

  showResults(points, postalCode) {
    const formEl = this.querySelector("[ref=pickerForm]");
    const errorEl = this.querySelector("[ref=errorMsg]");
    if (errorEl) errorEl.classList.add("hidden");

    let resultsEl = this.querySelector("[ref=resultsContainer]");
    if (!resultsEl) {
      resultsEl = document.createElement("div");
      resultsEl.setAttribute("ref", "resultsContainer");
      resultsEl.className = "sendcloud-sp__results";
      formEl.parentNode.insertBefore(resultsEl, formEl.nextSibling);
    }

    resultsEl.innerHTML = points.map(sp => {
      const addr = [sp.street, sp.house_number].filter(Boolean).join(" ") +
        ", " + (sp.postal_code || "") + " " + (sp.city || "");
      const hours = sp.formatted_opening_times ?
        Object.entries(sp.formatted_opening_times)
          .filter(([,v]) => v && v.length)
          .slice(0, 3)
          .map(([d,v]) => d.substring(0,2).toUpperCase() + ": " + v.join(", "))
          .join(" | ") : "";
      return '<button type="button" class="sendcloud-sp__result-item" data-sp=\'' +
        JSON.stringify({id: sp.id, name: sp.name, carrier: sp.carrier, address: addr, post_number: sp.code || ""}).replace(/'/g, "&apos;") +
        '\' data-postal="' + postalCode + '">' +
        '<span class="sendcloud-sp__result-carrier">' + (sp.carrier || "").toUpperCase().replace("_", " ") + '</span>' +
        '<strong class="sendcloud-sp__result-name">' + (sp.name || "") + '</strong>' +
        '<span class="sendcloud-sp__result-address">' + addr + '</span>' +
        (hours ? '<span class="sendcloud-sp__result-hours">' + hours + '</span>' : '') +
        '</button>';
    }).join("");

    resultsEl.classList.remove("hidden");
    if (formEl) formEl.classList.add("hidden");

    resultsEl.querySelectorAll(".sendcloud-sp__result-item").forEach(item => {
      item.addEventListener("click", () => this.selectPoint(item));
    });
  }

  async selectPoint(item) {
    const sp = JSON.parse(item.dataset.sp);
    const postalCode = item.dataset.postal || "";

    const carrierLabel = (sp.carrier || "").toUpperCase().replace("_", " ");
    const noteText = "Punto de recogida: " + (sp.name || "") + " (" + carrierLabel + ") - " + (sp.address || "");

    const body = JSON.stringify({
      note: noteText,
      attributes: {
        _sendcloud_service_point_id: String(sp.id),
        _sendcloud_to_post_number: sp.post_number || "",
        _sendcloud_carrier: sp.carrier || "",
        _sendcloud_service_point_name: sp.name || "",
        _sendcloud_service_point_address: sp.address || "",
        _sendcloud_postal_code: postalCode,
      },
    });

    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
      });
    } catch {}

    const selectedEl = this.querySelector("[ref=selectedPoint]");
    const resultsEl = this.querySelector("[ref=resultsContainer]");

    if (selectedEl) {
      selectedEl.classList.remove("hidden");
      const carrierEl = selectedEl.querySelector("[ref=spCarrier]") || selectedEl.querySelector(".sendcloud-sp__selected-carrier");
      const nameEl = selectedEl.querySelector("[ref=spName]") || selectedEl.querySelector(".sendcloud-sp__selected-name");
      const addressEl = selectedEl.querySelector("[ref=spAddress]") || selectedEl.querySelector(".sendcloud-sp__selected-address");
      if (carrierEl) carrierEl.textContent = (sp.carrier || "").toUpperCase().replace("_", " ");
      if (nameEl) nameEl.textContent = sp.name || "";
      if (addressEl) addressEl.textContent = sp.address || "";
    }
    if (resultsEl) resultsEl.classList.add("hidden");
  }

  showError(msg) {
    const errorEl = this.querySelector("[ref=errorMsg]");
    if (errorEl) {
      const textEl = errorEl.querySelector(".sendcloud-sp__error-text");
      if (textEl) textEl.textContent = msg;
      errorEl.classList.remove("hidden");
    }
    const resultsEl = this.querySelector("[ref=resultsContainer]");
    if (resultsEl) resultsEl.classList.add("hidden");
  }

  async clearServicePoint() {
    const body = JSON.stringify({
      note: "",
      attributes: {
        _sendcloud_service_point_id: "",
        _sendcloud_to_post_number: "",
        _sendcloud_carrier: "",
        _sendcloud_service_point_name: "",
        _sendcloud_service_point_address: "",
        _sendcloud_postal_code: "",
      },
    });

    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
      });
    } catch {}

    const selectedEl = this.querySelector("[ref=selectedPoint]");
    const formEl = this.querySelector("[ref=pickerForm]");
    const resultsEl = this.querySelector("[ref=resultsContainer]");

    if (selectedEl) selectedEl.classList.add("hidden");
    if (formEl) formEl.classList.remove("hidden");
    if (resultsEl) resultsEl.classList.add("hidden");
  }
}

if (!customElements.get("sendcloud-service-point")) {
  customElements.define("sendcloud-service-point", SendcloudServicePoint);
}
